import type { Stat } from '~/content/types';
import { defaultStats } from '~/content/shared';
import { Section } from '~/components/layout';
import { Icon } from '~/components/ui';
import { ScrollStrip } from './ScrollStrip';

/**
 * Horizontal stats strip (Figma 27:6434) — an instance of the shared
 * {@link ScrollStrip}. Each item is a fixed 280px wide with a 40px inner left
 * padding; when the viewport is too narrow the track becomes a
 * horizontally drag-scrollable / cropped strip.
 */
export function StatsRow({
  stats = defaultStats,
  className,
}: {
  stats?: Stat[];
  className?: string;
}) {
  return (
    <ScrollStrip
      items={stats}
      getKey={(stat) => stat.label}
      // Mobile: 15px text, 24px icon, padding trimmed 4px (py-6→py-5, pl-10→pl-9);
      // desktop values preserved via md:. Auto-scrolls as a gentle marquee on
      // mobile only (static, drag-scrollable on desktop).
      autoScrollMobileOnly
      itemClassName="w-[280px] gap-5 py-5 pl-9 md:py-6 md:pl-10"
      className={className}
      renderItem={(stat) => (
        <>
          <Icon name={stat.icon} className="size-6 shrink-0 md:size-6" />
          <div className="flex flex-col gap-3">
            <p className="text-[15px] font-semibold text-ink md:text-body">{stat.value}</p>
            <p className="text-[15px] text-grey-900 md:text-body">{stat.label}</p>
          </div>
        </>
      )}
    />
  );
}

/** Standalone section wrapper around {@link StatsRow}. */
export function TrustBar({ stats = defaultStats }: { stats?: Stat[] }) {
  return (
    <Section className="py-6 md:py-8">
      <StatsRow stats={stats} />
    </Section>
  );
}
